// local
import Api from '.';

export function list() {
    return Api.get('/client');
}

export function create(data) {
    return Api.post('/client', data);
}

export function update(id, data) {
    return Api.put(`/client/${id}`, data);
}

export function updateStatus(id, data) {
    return Api.put(`/client/${id}/status`, data);
}

export default { list, create, update, updateStatus };
